import {
  Action,
  Actions,
  Header,
  PanelTitle,
  PrimaryAction,
  Root,
  Toolbar,
} from './side-panel.parts';

export const SidePanel = {
  Root,
  Header,
  Title: PanelTitle,
  Actions,
  Action,
  PrimaryAction,
  Toolbar,
};
